var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignoff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.4,
    height: 19.2,
    viewBox: "0 0 17.4 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.9;}.b{fill:#aa0100;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,2.6A.7.7,0,0,0,11,3a.7.7,0,0,0,.4,1,7.09,7.09,0,1,1-9.9,6.5,7.239,7.239,0,0,1,4-6.4.69.69,0,0,0,.5-1,.731.731,0,0,0-1-.4,8.671,8.671,0,1,0,12.4,7.8A8.854,8.854,0,0,0,12,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.7,9a.86.86,0,0,0,.8-.8V.8A.86.86,0,0,0,8.7,0a.86.86,0,0,0-.8.8V8.2A.789.789,0,0,0,8.7,9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoff);
export default __webpack_public_path__ + "static/media/signoff.5be0042235f46994aa12feeb871c0881.svg";
export { ForwardRef as ReactComponent };